import Joi from "joi";

export const quotationFileSchema = Joi.object({
  id: Joi.string().min(2).label("Id"),
  fileUrl: Joi.string().min(2).label("File url"),
  quotationRequestId: Joi.string().min(2).label("Quotation request"),
  fileName: Joi.string().min(2).allow(null).label("File name"),
  fileSize: Joi.number().min(0).allow(null).label("File size"),
});
